module.exports = __webpack_public_path__ + "img/icon-home-p2-layer.00a0089e.jpg";